import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {ContactSubmissionForm} from "./contact_submission_form"

export const contactSubmissionFormLoader = function (options = {}) {
    componentLoader(componentConfig(ContactSubmissionForm, ContactSubmissionForm.config.componentTypeKey, ContactSubmissionForm.config.baseHtmlClass), options);
};

